import Vue from 'vue'
import vuex from 'vuex'

Vue.use(vuex);

import app from './modules/app';
import user from './modules/user';

const store = new vuex.Store({
    modules:{
        app:app,
        user:user,
    },
    getters:{
        requestLoading:state=>state.app.requestLoading,
        backendMsgType:state=>state.app.backendMsgType,
        backendMsg:state=>state.app.backendMsg,
        theme:state=>state.app.theme,
        size:state=>state.app.size,
        
        token:state=>state.user.token,
        userInfo:state=>state.user.userInfo,
    },
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js